$(function () {
    $(window).on("load resize orientationchange", doMatchHeight);

    function doMatchHeight() {
        var mhOptions = {
            byRow: false,
            property: 'min-height',
            target: null,
            remove: false,
        };

        $(".bundle-grid__cards .payment-type-option").css('min-height', '');
        $(".cert-detail-cards-wrap .payment-type-option").css('min-height', '');
        $(".cert-detail-cards-wrap .cert-detail-card__affirm-wrap").css('min-height', '');
        $(".program-cards-wrap .product-card__affirm-wrap").css('min-height', '');

        $(".bundle-grid__cards .payment-type-option").matchHeight(mhOptions);
        $(".cert-detail-cards-wrap .payment-type-option").matchHeight(mhOptions);
        $(".cert-detail-cards-wrap .cert-detail-card__affirm-wrap").matchHeight(mhOptions);
        $(".program-cards-wrap .product-card__affirm-wrap").matchHeight(mhOptions);
    }
});
